/**
 * CUSTOMER CREATOR JS
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - 
 *
 */
import $ from 'jquery';
import aon_craft_step_navigation from './aon_craft_step_navigation.js';
import aon_craft_utils from './aon_craft_utils.js';
window.jQuery = $;

export default {
    init() {
        /*
         * Initialise SECTION 3A - CUSTOMER CREATOR UI, data
         * UI interaction functions
         */
        console.log( 'SECTION 3A - Customer Creator widget - init' );
        
        this.aon_customers_entries = [];
        
         // Customer component variables (some must be set in order to proceed past initial creation step)...
        this.body = '';
        this.eyes = '';
        this.nose = '';
        this.mouths = '';
        this.hair = '';
        this.fringes = '';
        this.accessories = '';
        this.hats = '';
        
        // Current customer ID (1, 2, 3)
        this.current_customer = 1;
        
        // Get any existing saved data...
        if ( $( '#business_plan' ).length > 0 ) { // If Business Plan page then load live data...
            //this.loadData( 'load_live' );
            // Technically this doesn't get called on the Business Plan page as it bypasses 'init()' and calls 'renderExistingCustomers' directly to get the existing customers
            
        } else { // If not Business Plan page then we are in 3A...
            if ( $( '#section_3a_data_json' ).val() != '' ) { // If JSON data field is not empty then we presume this is saved data and try to load it...
                //this.loadData( 'load_live' );
                this.renderExistingCustomers();
                aon_craft_step_navigation.changeStep( 8 );
                
            } else { // If no saved data then we start with a default data structure...
                this.loadData( 'start' ); 

            }
            //this.loadData( 'load_demo' );
        }
        
        // Select Tool type (Background, Body, etc)...
        var cc_type = $( '#cc_tools_type' ).val();
        $( 'body' ).on( 'change', '#cc_tools_type', ( event ) => { // Function defined using arrow method to gain access to main 'this'
            cc_type = $( '#cc_tools_type' ).val();
            $( '.customer_creator .tools ul' ).css( 'display', 'none' );
            $( '.customer_creator .tools ul.' + cc_type ).css( 'display', 'flex' );
            event.preventDefault();
        });

        // Click on Tool type button...
        $( 'body' ).on( 'click', '.tool_selection a', function( event ) {
            var targ = $( this ).attr( 'class' ).replace( 'active', '' );
            console.log( 'targ: ' + targ );
            var parent = $( this ).parent().parent( 'ul').attr( 'class' ).replace('active', '').trim();
            $( '#customer_dynamic .main svg .' + parent + ' g, #customer_dynamic .main svg .' + parent + ' path' ).hide();
            $( '#customer_dynamic .main svg .' + parent + ' .' + targ + ', #customer_dynamic .main svg .' + parent + ' .' + targ + ' g' + ', #customer_dynamic .main svg .' + parent + ' .' + targ + ' path' ).show();
            if ( parent == 'background' && targ != 'none' ) {
                $( '.main-background' ).hide();
                console.log( 'targ: ' + targ );
            } else if ( parent == 'background' && targ == 'none' ) {
                $( '.main-background' ).show();
            }
            
            setCustomerComponents( parent, targ );
            
            $( 'ul.' + parent + ' li a' ).removeClass( 'active' );
            $( this ).addClass( 'active' );
            
            // Scroll back up to show Character Panel when clicking, primarily of benefit for mobile users when character appears above the tools
            Foundation.SmoothScroll.scrollToLoc( '#customer_dynamic', {
                    threshold: 25,
                    offset: 0
                }, function() {
                    console.log( 'scrolled' );
                }
            );
            
            event.preventDefault();
        });
        
        var setCustomerComponents = ( parent, targ ) => {
            if ( parent == 'body' ) {
                if ( targ != 'none' ) {
                    this.body = targ;
                } else {
                    this.body = '';
                }
            }
            if ( parent == 'eyes' ) {
                if ( targ != 'none' ) {
                    this.eyes = targ;
                } else {
                    this.eyes = '';
                }
            }
            if ( parent == 'noses' ) {
                if ( targ != 'none' ) {
                    this.nose = targ;
                } else {
                    this.nose = '';
                }
            }
            if ( parent == 'mouths' ) {
                if ( targ != 'none' ) {
                    this.mouths = targ;
                } else {
                    this.mouths = '';
                }
            }
            if ( parent == 'hair' ) {
                if ( targ != 'none' ) {
                    this.hair = targ;
                } else {
                    this.hair = '';
                }
            }
            if ( parent == 'fringes' ) {
                if ( targ != 'none' ) {
                    this.fringes = targ;
                } else {
                    this.fringes = '';
                }
            }
            if ( parent == 'accessories' ) {
                if ( targ != 'none' ) {
                    this.accessories = targ;
                } else {
                    this.accessories = '';
                }
            }
            if ( parent == 'hats' ) {
                if ( targ != 'none' ) {
                    this.hats = targ;
                } else {
                    this.hats = '';
                }
            }
            
            checkCustomerImageCompleted();
        }
        
        var checkCustomerImageCompleted = () => {
            // Changed this to require only 1 of any of the parameters to be selected before continuing...
            console.log( this.body + ' - ' + this.eyes + ' - ' + this.nose + ' - ' + this.mouths + ' - ' + this.hair + ' - ' + this.fringes + ' - ' + this.accessories + ' - ' + this.hats );
            if ( this.body != '' || this.eyes != '' || this.nose != '' || this.mouths != '' || this.hair != '' || this.fringes != '' || this.accessories != '' || this.hats != '' ) {
                $( '.customer_creator_next' ).removeClass( 'disabled ');
            } else {
                $( '.customer_creator_next' ).addClass( 'disabled ');
            }
        }
        
        var getCurrentCustomer = () => {
            return this.current_customer;
        }
        
        // Click on Next button Calculating Income page, copy yearly income to total field...
        $( 'body' ).on( 'click', '.customer_creator_next', ( event ) => {
            $( '#customer_complete .main svg').remove();
            $( '#customer_dynamic .main svg').clone().appendTo( '#customer_complete .main .svg_wrapper' );
            $( '#customer_' + getCurrentCustomer() + ' .main svg').remove();
            $( '#customer_dynamic .main svg').clone().appendTo( '#customer_' + getCurrentCustomer() + ' .main .svg_wrapper' );
            $( '.customer_' + getCurrentCustomer() + ' .thumbnail, .customer_' + getCurrentCustomer() + ' .total' ).show();
            console.log( 'this.current_customer-1: ' );
            console.log( this.current_customer-1 );
            this.saveCustomerImage( this.current_customer-1, this.body, this.eyes, this.nose, this.mouths, this.hair, this.fringes, this.accessories, this.hats )
            event.preventDefault();
        });
        
        var checkCurrentCustomerSetIncomeText = ( income ) => {
            if ( this.current_customer == 1 ) {
                $( '.customer_1 .total_text' ).text( income );
                
            } else if ( this.current_customer == 2 ) {
                $( '.customer_2 .total_text' ).text( income );
                
            } else if ( this.current_customer == 3 ) {
                $( '.customer_3 .total_text' ).text( income );
            }
        }

        var setCurrentCustomerMemorableName = ( name ) => {
            if ( this.current_customer == 1 ) {
                $( '.customer_1 .memorable_name' ).text( name );
                
            } else if ( this.current_customer == 2 ) {
                $( '.customer_2 .memorable_name' ).text( name );
                
            } else if ( this.current_customer == 3 ) {
                $( '.customer_3 .memorable_name' ).text( name );
            }
        }

        
        // Check fields are complete on 'add_customer_details_form' before enabling 'Next' button...
        $( 'body' ).on( 'keyup change', '#add_customer_details_form textarea, #add_customer_details_form select', function( event ) {
            var add_customer_details_age = $( '#add_customer_details_age' ).val();
            var add_customer_details_live = $( '#add_customer_details_live' ).val();
            var add_customer_details_interests = $( '#add_customer_details_interests' ).val();
            var add_customer_details_habits = $( '#add_customer_details_habits' ).val();
            var add_customer_details_activities = $( '#add_customer_details_activities' ).val();
            var add_customer_details_feel_strongly = $( '#add_customer_details_feel_strongly' ).val();
            if ( add_customer_details_age == '' || add_customer_details_live == '' || add_customer_details_interests == '' || add_customer_details_habits == '' || add_customer_details_activities == '' || add_customer_details_feel_strongly == '' ) {
                $( '.customer_details_next' ).addClass( 'disabled' );
            } else {
                $( '.customer_details_next' ).removeClass( 'disabled' );
            }
            console.log( 'checking add_customer_details_form... ' );
            event.preventDefault();
        });
        
        
        // Check fields are complete on 'add_customer_details_form' before enabling 'Next' button...
        $( 'body' ).on( 'keyup', '#add_customer_buying_habits_form textarea', function( event ) {
            var add_customer_buying_habits_product = $( '#add_customer_buying_habits_product' ).val();
            var add_customer_buying_habits_buy_from_you = $( '#add_customer_buying_habits_buy_from_you' ).val();
            var add_customer_buying_habits_buy_for_them = $( '#add_customer_buying_habits_buy_for_them' ).val();
            var add_customer_buying_habits_buy_directly_from_you = $( '#add_customer_buying_habits_buy_directly_from_you' ).val();
            var add_customer_buying_habits_how_will_you_reach = $( '#add_customer_buying_habits_how_will_you_reach' ).val();
            if ( add_customer_buying_habits_product == '' || add_customer_buying_habits_buy_from_you == '' || add_customer_buying_habits_buy_for_them == '' || add_customer_buying_habits_buy_directly_from_you == '' || add_customer_buying_habits_how_will_you_reach == '' ) {
                $( '.buying_habits_next' ).addClass( 'disabled' );
            } else {
                $( '.buying_habits_next' ).removeClass( 'disabled' );
            }
            console.log( 'checking add_customer_buying_habits_form... ' );
            event.preventDefault();
        });
        
        // Check fields are complete on 'add_customer_details_form' before enabling 'Next' button...
        // Calculating Income fields...
        $( 'body' ).on( 'keyup', '#add_customer_calculating_income_form input', function( event ) {
            var add_customer_calculating_income_spend_with_you = $( '#add_customer_calculating_income_spend_with_you' ).val();
            var add_customer_calculating_income_how_many_customers = $( '#add_customer_calculating_income_how_many_customers' ).val();
            if ( add_customer_calculating_income_spend_with_you == '' || add_customer_calculating_income_how_many_customers == '' ) {
                $( '.calculating_income_next' ).addClass( 'disabled' );
            } else {
                $( '.calculating_income_next' ).removeClass( 'disabled' );
            }
            if ( add_customer_calculating_income_spend_with_you != '' && add_customer_calculating_income_how_many_customers != '' ) {
                var yearly_total = add_customer_calculating_income_spend_with_you * add_customer_calculating_income_how_many_customers;
                $( '.add_customer_yearly_income .total_text').text( yearly_total );
            }
            console.log( 'checking add_customer_calculating_income_form... ' );
            event.preventDefault();
        });

        // Memorable Name field...
        $( 'body' ).on( 'keyup', '#add_customer_memorable_name_form input', function( event ) {
            var add_customer_memorable_name = $( '#add_customer_memorable_name' ).val();
            if ( add_customer_memorable_name == '' ) {
                $( '.memorable_name_next' ).addClass( 'disabled' );
            } else {
                $( '.memorable_name_next' ).removeClass( 'disabled' );
            }
            console.log( 'checking add_customer_memorable_name_form... ' );
            event.preventDefault();
        });
        
        // Click on Memorable Name Next button...
        $( 'body' ).on( 'click', '.memorable_name_next', ( event ) => {
            var add_customer_memorable_name = aon_craft_utils.removeHTMLTags( $( '#add_customer_memorable_name' ).val() );
            $( '#add_customer_memorable_name' ).val( add_customer_memorable_name );
            setCurrentCustomerMemorableName( add_customer_memorable_name );
            this.saveCustomerMemorableName( this.current_customer-1, add_customer_memorable_name );
			this.saveData();
            event.preventDefault();
        });
        

        
        // Click on Customer Details Next button...
        $( 'body' ).on( 'click', '.customer_details_next', ( event ) => {
            var customer_details_age = aon_craft_utils.removeHTMLTags( $( '#add_customer_details_age' ).val() );
			
            var customer_details_live = aon_craft_utils.removeHTMLTags( $( '#add_customer_details_live' ).val() );
            $( '#add_customer_details_live' ).val( customer_details_live );
			
            var customer_details_interests = aon_craft_utils.removeHTMLTags( $( '#add_customer_details_interests' ).val() );
            $( '#add_customer_details_interests' ).val( customer_details_interests );
			
            var customer_details_habits = aon_craft_utils.removeHTMLTags( $( '#add_customer_details_habits' ).val() );
            $( '#add_customer_details_habits' ).val( customer_details_habits );
			
            var customer_details_activities = aon_craft_utils.removeHTMLTags( $( '#add_customer_details_activities' ).val() );
            $( '#add_customer_details_activities' ).val( customer_details_activities );
			
            var customer_details_feel_strongly = aon_craft_utils.removeHTMLTags( $( '#add_customer_details_feel_strongly' ).val() );
            $( '#add_customer_details_feel_strongly' ).val( customer_details_feel_strongly );
			
            this.saveCustomerDetails( this.current_customer-1, customer_details_age, customer_details_live, customer_details_interests, customer_details_habits, customer_details_activities, customer_details_feel_strongly );
            event.preventDefault();
        });
        
        
        // Click on Buying Habits Next button...
        $( 'body' ).on( 'click', '.buying_habits_next', ( event ) => {
            var customer_buying_habits_product = aon_craft_utils.removeHTMLTags( $( '#add_customer_buying_habits_product' ).val() );
            $( '#add_customer_buying_habits_product' ).val( customer_buying_habits_product );
			
            var customer_buying_habits_buy_from_you = aon_craft_utils.removeHTMLTags( $( '#add_customer_buying_habits_buy_from_you' ).val() );
            $( '#add_customer_buying_habits_buy_from_you' ).val( customer_buying_habits_buy_from_you );
			
            var customer_buying_habits_buy_for_them = aon_craft_utils.removeHTMLTags( $( '#add_customer_buying_habits_buy_for_them' ).val() );
            $( '#add_customer_buying_habits_buy_for_them' ).val( customer_buying_habits_buy_for_them );
			
            var customer_buying_habits_buy_directly_from_you = aon_craft_utils.removeHTMLTags( $( '#add_customer_buying_habits_buy_directly_from_you' ).val() );
            $( '#add_customer_buying_habits_buy_directly_from_you' ).val( customer_buying_habits_buy_directly_from_you );
			
            var customer_buying_habits_how_will_you_reach = aon_craft_utils.removeHTMLTags( $( '#add_customer_buying_habits_how_will_you_reach' ).val() );
            $( '#add_customer_buying_habits_how_will_you_reach' ).val( customer_buying_habits_how_will_you_reach );
			
            this.saveCustomerBuyingHabits( this.current_customer-1, customer_buying_habits_product, customer_buying_habits_buy_from_you, customer_buying_habits_buy_for_them, customer_buying_habits_buy_directly_from_you, customer_buying_habits_how_will_you_reach );
            event.preventDefault();
        });
        
        // Click on Next button Calculating Income page...
        $( 'body' ).on( 'click', '.calculating_income_next', ( event ) => {
            var yearly_income = aon_craft_utils.removeHTMLTags( $( '.add_customer_yearly_income .total_text' ).text() );
            checkCurrentCustomerSetIncomeText( yearly_income );
            var customer_calculating_income_spend_with_you = aon_craft_utils.removeHTMLTags( $( '#add_customer_calculating_income_spend_with_you' ).val() );
            var customer_calculating_income_how_many_customers = aon_craft_utils.removeHTMLTags( $( '#add_customer_calculating_income_how_many_customers' ).val() );
            this.saveCustomerIncome( this.current_customer-1, yearly_income, customer_calculating_income_spend_with_you, customer_calculating_income_how_many_customers );
            
            if ( $( '#customer_1 svg').length > 0 && $( '#customer_2 svg').length > 0 && $( '#customer_3 svg').length > 0 ) {
                $( '.customer_groups_next' ).removeClass( 'disabled' );
            } else {
                $( '.customer_groups_next' ).addClass( 'disabled' );
            }
            
            event.preventDefault();
        });
        
        
        
        // Click on ADD Customer to go start / reset process for Customers 1, 2 & 3...
        $( 'body' ).on( 'click', '.add_customer', function( event ) {
//            if ( $( this ).hasClass( 'add_customer' ) ) {
                var parent = $( this ).parent();
                console.log( 'add_customer: ' + parent.attr( 'class' ) );
                localAddCustomerDataEntry();
//                
//            } else if ( $( this ).hasClass( 'redo_customer' ) ) {
//                var parent = $( this ).parent().parent();
//                console.log( 'redo_customer: ' + parent.attr( 'class' ) );
//            }
            
            if ( parent.hasClass( 'customer_1' ) ) {
                localSetCurrentCustomer( 1 );
                localResetCustomerCreatorProcess();
                aon_craft_step_navigation.changeStep( 3 );
                $( '.customer_1 .thumbnail, .customer_1 .total' ).show();
                $( '.customer_1 .add_customer' ).hide();
                $( '.customer_1 .redo_customer' ).show();
                $( '#customer_1 .main svg').remove();
                
            } else if ( parent.hasClass( 'customer_2' ) ) {
                localSetCurrentCustomer( 2 );
                localResetCustomerCreatorProcess();
                aon_craft_step_navigation.changeStep( 3 );
                $( '.customer_2 .thumbnail, .customer_2 .total' ).show();
                $( '.customer_2 .add_customer' ).hide();
                $( '.customer_2 .redo_customer' ).show();
                $( '#customer_2 .main svg').remove();
                
            } else if ( parent.hasClass( 'customer_3' ) ) {
                localSetCurrentCustomer( 3 );
                localResetCustomerCreatorProcess();
                aon_craft_step_navigation.changeStep( 3 );
                $( '.customer_3 .thumbnail, .customer_3 .total' ).show();
                $( '.customer_3 .add_customer' ).hide();
                $( '.customer_3 .redo_customer' ).show();
                $( '#customer_3 .main svg').remove();
            }
            event.preventDefault();
        });
        
        // Click on REDO Customer to go redo process for Customers 1, 2 & 3...
        $( 'body' ).on( 'click', '.redo_customer', function( event ) {
            var parent = $( this ).parent().parent();
            console.log( 'redo_customer: ' + parent.attr( 'class' ) );
            
            if ( parent.hasClass( 'customer_1' ) ) {
                localSetCurrentCustomer( 1 );
                localRedoExistingCustomerCreatorProcess();
                aon_craft_step_navigation.changeStep( 3 );
                $( '.customer_1 .thumbnail, .customer_1 .total' ).show();
                $( '.customer_1 .add_customer' ).hide();
                $( '.customer_1 .redo_customer' ).show();
                $( '#customer_1 .main svg').remove();
                
            } else if ( parent.hasClass( 'customer_2' ) ) {
                localSetCurrentCustomer( 2 );
                localRedoExistingCustomerCreatorProcess();
                aon_craft_step_navigation.changeStep( 3 );
                $( '.customer_2 .thumbnail, .customer_2 .total' ).show();
                $( '.customer_2 .add_customer' ).hide();
                $( '.customer_2 .redo_customer' ).show();
                $( '#customer_2 .main svg').remove();
                
            } else if ( parent.hasClass( 'customer_3' ) ) {
                localSetCurrentCustomer( 3 );
                localRedoExistingCustomerCreatorProcess();
                aon_craft_step_navigation.changeStep( 3 );
                $( '.customer_3 .thumbnail, .customer_3 .total' ).show();
                $( '.customer_3 .add_customer' ).hide();
                $( '.customer_3 .redo_customer' ).show();
                $( '#customer_3 .main svg').remove();
            }
            event.preventDefault();
        });
		
		// Customer entry hover / highlighting...
        $( 'body' ).on( 'mouseenter', '.redo_customer', function() {
			$( '.redo_customer' ).addClass( 'fade' );
			$( this ).removeClass( 'fade' );
			$( this ).find( $( '.customer-edit-tooltip' ) ).remove();
			var edit_tooltip = $( '.customer-edit-tooltip.hide' ).clone();
			edit_tooltip.removeClass( 'hide' );
			$( this ).append( edit_tooltip );
        });

        $( 'body' ).on( 'mouseleave', '.redo_customer', function() {
			$( '.redo_customer' ).removeClass( 'fade' );
			$( this ).find( $( '.customer-edit-tooltip' ) ).remove();
        });
        
        var localAddCustomerDataEntry = () => {
            this.addCustomerDataEntry();
        }
        
        var localSetCurrentCustomer = ( int ) => {
            this.setCurrentCustomer( int );
        }
        
        var localResetCustomerCreatorProcess = () => {
            this.resetCustomerCreatorProcess();
        }
        
        var localRedoExistingCustomerCreatorProcess = () => {
            //this.redoExistingCustomerCreatorProcess();
            this.resetCustomerCreatorProcess();
            this.renderCustomer();
        }
        
        // Click on 'save_data' to submit completed data to backend storage...
        $( 'body' ).on( 'click', '.save_data', ( event ) => {
            this.saveData();
        });

    },
    
    /*redoExistingCustomerCreatorProcess() {
        console.log( 'REDO Customer Creator Process' );
        // First reset all the things...
        $( '#customer_dynamic .main svg .accessories g, #customer_dynamic .main svg .accessories path' ).hide();
        $( '#customer_dynamic .main svg .hats' ).children( 'g' ).hide();
        $( '#customer_dynamic .main svg .hats' ).children( 'path' ).hide();
        $( '#customer_dynamic .main svg .eyes' ).children( 'g' ).hide();
        $( '#customer_dynamic .main svg .eyes' ).children( 'path' ).hide();
        $( '#customer_dynamic .main svg .fringes' ).children( 'g' ).hide();
        $( '#customer_dynamic .main svg .fringes' ).children( 'path' ).hide();
        $( '#customer_dynamic .main svg .noses' ).children( 'g' ).hide();
        $( '#customer_dynamic .main svg .noses' ).children( 'path' ).hide();
        $( '#customer_dynamic .main svg .mouths' ).children( 'g' ).hide();
        $( '#customer_dynamic .main svg .mouths' ).children( 'path' ).hide();
        $( '#customer_dynamic .main svg .body' ).children( 'g' ).hide();
        $( '#customer_dynamic .main svg .body' ).children( 'path' ).hide();
        $( '#customer_dynamic .main svg .hair' ).children( 'g' ).hide();
        $( '#customer_dynamic .main svg .hair' ).children( 'path' ).hide();
        $( '#cc_tools_type' ).val( 'body' ).change();
        $( '.tool_selection li a' ).removeClass( 'active' );
        $( '.tool_selection li a.none' ).addClass( 'active' );
        
        // Now set the specific settings for the customer...
//        this.body = '';
//        this.eyes = '';
//        this.nose = '';
//        this.mouths = '';
//        this.hair = '';
//        this.fringes = '';
//        this.accessories = '';
//        this.hats = '';
//        $( this ).addClass( 'active' );
        //$( '#customer_dynamic .main svg .hats .' + this.hats );
    },*/
    
    resetCustomerCreatorProcess() {
        console.log( 'RESET Customer Creator Process' );
        $( '#customer_dynamic .main svg .accessories g, #customer_dynamic .main svg .accessories path' ).hide();
        $( '#customer_dynamic .main svg .hats' ).children( 'g' ).hide();
        $( '#customer_dynamic .main svg .hats' ).children( 'path' ).hide();
        $( '#customer_dynamic .main svg .eyes' ).children( 'g' ).hide();
        $( '#customer_dynamic .main svg .eyes' ).children( 'path' ).hide();
        $( '#customer_dynamic .main svg .fringes' ).children( 'g' ).hide();
        $( '#customer_dynamic .main svg .fringes' ).children( 'path' ).hide();
        $( '#customer_dynamic .main svg .noses' ).children( 'g' ).hide();
        $( '#customer_dynamic .main svg .noses' ).children( 'path' ).hide();
        $( '#customer_dynamic .main svg .mouths' ).children( 'g' ).hide();
        $( '#customer_dynamic .main svg .mouths' ).children( 'path' ).hide();
        $( '#customer_dynamic .main svg .body' ).children( 'g' ).hide();
        $( '#customer_dynamic .main svg .body' ).children( 'path' ).hide();
        $( '#customer_dynamic .main svg .hair' ).children( 'g' ).hide();
        $( '#customer_dynamic .main svg .hair' ).children( 'path' ).hide();
        $( '#cc_tools_type' ).val( 'body' ).change();
        $( '.tool_selection li a' ).removeClass( 'active' );
        $( '.tool_selection li a.none' ).addClass( 'active' );
        
        $( '#add_customer_details_age' ).val( '' ).change();
        
        $( 'input[type="text"]' ).val( '' );
        $( 'input[type="number"]' ).val( '' );
        $( 'textarea' ).val( '' );
        $( '.add_customer_yearly_income .total_text' ).text( '' );
        $( '.customer_details_next' ).addClass( 'disabled' );
        $( '.buying_habits_next' ).addClass( 'disabled' );
        $( '.calculating_income_next' ).addClass( 'disabled' );
        this.body = '';
        this.eyes = '';
        this.nose = '';
        this.mouths = '';
        this.hair = '';
        this.fringes = '';
        this.accessories = '';
        this.hats = '';
        $( this ).addClass( 'active' );
    },
    
    setCurrentCustomer( int ) {
        this.current_customer = int;
        console.log( 'current_customer: ' + this.current_customer );
    },
    
    renderCustomer() {
        console.log( 'renderCustomer - Start' );
        // Render Customer data into main SVG configurator and set Text fields and Dropdowns etc...
        
        /*// Loop over entries array...
        var entry_count = 1;
        $.each( this.aon_customers_entries, function( index ) {
            // Loop over data entries...   
            console.log( 'renderCustomer - Loop over data entries...' );
            // Show / Hide add / redo links and clone SVG...
            
            $( '#customer_' + entry_count + ' .main svg').remove();
            $( '#customer_dynamic .main svg').clone().appendTo( '#customer_' + entry_count + ' .main .svg_wrapper' );
            // Display SVG elements for the final Thumbnails...
            if ( this.body != '' ) {
                $( '#customer_' + entry_count + ' .main .body .' + this.body ).show();
            }
            if ( this.eyes != '' ) {
                $( '#customer_' + entry_count + ' .main .eyes .' + this.eyes ).show();
            }
            if ( this.noses != '' ) {
                $( '#customer_' + entry_count + ' .main .noses .' + this.noses ).show();
            }
            if ( this.mouths != '' ) {
                $( '#customer_' + entry_count + ' .main .mouths .' + this.mouths ).show();
            }
            if ( this.hair != '' ) {
                $( '#customer_' + entry_count + ' .main .hair .' + this.hair ).show();
            }
            if ( this.fringes != '' ) {
                $( '#customer_' + entry_count + ' .main .fringes .' + this.fringes ).show();
            }
            if ( this.accessories != '' ) {
                $( '#customer_' + entry_count + ' .main .accessories .' + this.accessories ).show();
            }
            if ( this.hats != '' ) {
                $( '#customer_' + entry_count + ' .main .hats .' + this.hats ).show();
            }
            
            if ( this.body != '' && this.eyes != '' && this.noses != '' && this.mouths != '' && this.hair != '' ) {
                $( '.customer_' + entry_count + ' .add_customer' ).hide();
                $( '.customer_' + entry_count + ' .thumbnail, .customer_' + entry_count + ' .total' ).show();
            } else {
                $( '.customer_' + entry_count + ' .redo_customer' ).show();
                $( '.customer_' + entry_count + ' .thumbnail, .customer_' + entry_count + ' .total' ).hide();
            }
            
            // Set Income text on final step...
            $( '.customer_' + entry_count + ' .total_text' ).text( this.yearly_income );
            
            entry_count++;
            
        });*/
        
        var id = this.current_customer - 1;
        
        // Display SVG elements for Customer 1...
        if ( this.aon_customers_entries[ id ][ 'body' ] != '' ) {
            $( '#customer_dynamic .main .body .' + this.aon_customers_entries[ id ][ 'body' ] ).show();
            //$( '.main-background' ).hide();
        }
        if ( this.aon_customers_entries[ id ][ 'eyes' ] != '' ) {
            $( '#customer_dynamic .main .eyes .' + this.aon_customers_entries[ id ][ 'eyes' ] ).show();
        }
        if ( this.aon_customers_entries[ id ][ 'noses' ] != '' ) {
            $( '#customer_dynamic .main .noses .' + this.aon_customers_entries[ id ][ 'noses' ] ).show();
        }
        if ( this.aon_customers_entries[ id ][ 'mouths' ] != '' ) {
            $( '#customer_dynamic .main .mouths .' + this.aon_customers_entries[ id ][ 'mouths' ] ).show();
        }
        if ( this.aon_customers_entries[ id ][ 'hair' ] != '' ) {
            $( '#customer_dynamic .main .hair .' + this.aon_customers_entries[ id ][ 'hair' ] ).show();
        }
        if ( this.aon_customers_entries[ id ][ 'fringes' ] != '' ) {
            $( '#customer_dynamic .main .fringes .' + this.aon_customers_entries[ id ][ 'fringes' ] ).show();
        }
        if ( this.aon_customers_entries[ id ][ 'accessories' ] != '' ) {
            $( '#customer_dynamic .main .accessories .' + this.aon_customers_entries[ id ][ 'accessories' ] ).show();
        }
        if ( this.aon_customers_entries[ id ][ 'hats' ] != '' ) {
            $( '#customer_dynamic .main .hats .' + this.aon_customers_entries[ id ][ 'hats' ] ).show();
        }
        
		//if ( this.body != '' || this.eyes != '' || this.nose != '' || this.mouths != '' || this.hair != '' || this.fringes != '' || this.accessories != '' || this.hats != '' ) {
        //if ( this.aon_customers_entries[ id ][ 'body' ] != '' && this.aon_customers_entries[ id ][ 'eyes' ] != '' && this.aon_customers_entries[ id ][ 'noses' ] != '' && this.aon_customers_entries[ id ][ 'mouths' ] != '' && this.aon_customers_entries[ id ][ 'hair' ] != '' ) {
        if ( this.aon_customers_entries[ id ][ 'body' ] != '' || this.aon_customers_entries[ id ][ 'eyes' ] != '' || this.aon_customers_entries[ id ][ 'noses' ] != '' || this.aon_customers_entries[ id ][ 'mouths' ] != '' || this.aon_customers_entries[ id ][ 'hair' ] != '' || this.aon_customers_entries[ id ][ 'fringes' ] != '' || this.aon_customers_entries[ id ][ 'accessories' ] != '' || this.aon_customers_entries[ id ][ 'hats' ] != '' ) {
            $( '.customer_creator_next' ).removeClass( 'disabled' );
        } else {
            $( '.customer_creator_next' ).addClass( 'disabled' );
        }
              
        // Set Customer Details text for Customer...
        $( '#add_customer_details_age' ).val( this.aon_customers_entries[ id ][ 'customer_details_age' ] ).change();
        $( '#add_customer_details_live' ).val( this.aon_customers_entries[ id ][ 'customer_details_live' ] );
        $( '#add_customer_details_interests' ).val( this.aon_customers_entries[ id ][ 'customer_details_interests' ] );
        $( '#add_customer_details_habits' ).val( this.aon_customers_entries[ id ][ 'customer_details_habits' ] );
        $( '#add_customer_details_activities' ).val( this.aon_customers_entries[ id ][ 'customer_details_activities' ] );
        $( '#add_customer_details_feel_strongly' ).val( this.aon_customers_entries[ id ][ 'customer_details_feel_strongly' ] );
        if ( this.aon_customers_entries[ id ][ 'customer_details_age' ] == '' || this.aon_customers_entries[ id ][ 'customer_details_live' ] == '' || this.aon_customers_entries[ id ][ 'customer_details_interests' ]  == '' || this.aon_customers_entries[ id ][ 'customer_details_habits' ] == '' || this.aon_customers_entries[ id ][ 'customer_details_activities' ] == '' || this.aon_customers_entries[ id ][ 'customer_details_feel_strongly' ] == '' ) {
            $( '.customer_details_next' ).addClass( 'disabled' );
        } else {
            $( '.customer_details_next' ).removeClass( 'disabled' );
        }
        
        
        // Set Buying Habits text for Customer...
        $( '#add_customer_buying_habits_product' ).val( this.aon_customers_entries[ id ][ 'buying_habits_product' ] );
        $( '#add_customer_buying_habits_buy_from_you' ).val( this.aon_customers_entries[ id ][ 'buying_habits_buy_from_you' ] );
        $( '#add_customer_buying_habits_buy_for_them' ).val( this.aon_customers_entries[ id ][ 'buying_habits_buy_for_them' ] );
        $( '#add_customer_buying_habits_buy_directly_from_you' ).val( this.aon_customers_entries[ id ][ 'buying_habits_buy_directly_from_you' ] );
        $( '#add_customer_buying_habits_how_will_you_reach' ).val( this.aon_customers_entries[ id ][ 'buying_habits_how_will_you_reach' ] );
        if ( this.aon_customers_entries[ id ][ 'buying_habits_product' ] == '' || this.aon_customers_entries[ id ][ 'buying_habits_buy_from_you' ] == '' || this.aon_customers_entries[ id ][ 'buying_habits_buy_for_them' ] == '' || this.aon_customers_entries[ id ][ 'buying_habits_buy_directly_from_you' ] == '' || this.aon_customers_entries[ id ][ 'buying_habits_how_will_you_reach' ] == '' ) {
            $( '.buying_habits_next' ).addClass( 'disabled' );
        } else {
            $( '.buying_habits_next' ).removeClass( 'disabled' );
        }
        
        // Set Income text for Customer...
        //$( '.customer_1 .total_text' ).text( this.aon_customers_entries[ id ][ 'yearly_income' ] );
        $( '#add_customer_calculating_income_spend_with_you' ).val( this.aon_customers_entries[ id ][ 'customer_spend_with_you' ] );
        $( '#add_customer_calculating_income_how_many_customers' ).val( this.aon_customers_entries[ id ][ 'how_many_customers' ] );
        $( '.add_customer_yearly_income .total_text' ).text( this.aon_customers_entries[ id ][ 'yearly_income' ] );
        if ( this.aon_customers_entries[ id ][ 'customer_spend_with_you' ] == '' || this.aon_customers_entries[ id ][ 'how_many_customers' ] == '' || this.aon_customers_entries[ id ][ 'yearly_income' ] == '' ) {
            $( '.calculating_income_next' ).addClass( 'disabled' );
        } else {
            $( '.calculating_income_next' ).removeClass( 'disabled' );
        }
        
        // Set Memorable Name for Customer...
        if ( this.aon_customers_entries[ id ][ 'customer_memorable_name' ] == '' ) {
            $( '.memorable_name_next' ).addClass( 'disabled' );
        } else {
            $( '.memorable_name_next' ).removeClass( 'disabled' );
        }
        $( '#add_customer_memorable_name' ).val( this.aon_customers_entries[ id ][ 'customer_memorable_name' ] );
        
        // Set local array items...
        this.body = this.aon_customers_entries[ id ][ 'body' ];
        this.eyes = this.aon_customers_entries[ id ][ 'eyes' ];
        this.nose = this.aon_customers_entries[ id ][ 'noses' ];
        this.mouths = this.aon_customers_entries[ id ][ 'mouths' ];
        this.hair = this.aon_customers_entries[ id ][ 'hair' ];
        this.fringes = this.aon_customers_entries[ id ][ 'fringes' ];
        this.accessories = this.aon_customers_entries[ id ][ 'accessories' ];
        this.hats = this.aon_customers_entries[ id ][ 'hats' ];
        
        // Set active tools...
        if ( this.body != '' ) {
            $( '.body li a' ).removeClass( 'active' );
            $( '.body li a.' + this.body ).addClass( 'active' );
        }
        if ( this.eyes != '' ) {
            $( '.eyes li a' ).removeClass( 'active' );
            $( '.eyes li a.' + this.eyes ).addClass( 'active' );
        }
        if ( this.nose != '' ) {
            $( '.noses li a' ).removeClass( 'active' );
            $( '.noses li a.' + this.nose ).addClass( 'active' );
        }
        if ( this.mouths != '' ) {
            $( '.mouths li a' ).removeClass( 'active' );
            $( '.mouths li a.' + this.mouths ).addClass( 'active' );
        }
        if ( this.hair != '' ) {
            $( '.hair li a' ).removeClass( 'active' );
            $( '.hair li a.' + this.hair ).addClass( 'active' );
        }
        if ( this.fringes != '' ) {
            $( '.fringes li a' ).removeClass( 'active' );
            $( '.fringes li a.' + this.fringes ).addClass( 'active' );
        }
        if ( this.accessories != '' ) {
            $( '.accessories li a' ).removeClass( 'active' );
            $( '.accessories li a.' + this.accessories ).addClass( 'active' );
        }
        if ( this.hats != '' ) {
            $( '.hats li a' ).removeClass( 'active' );
            $( '.hats li a.' + this.hats ).addClass( 'active' );
        }
        
        
    },
    
    saveCustomerImage( id, body, eyes, noses, mouths, hair, fringes, accessories, hats ) {
        console.log( 'saveCustomerImage: ' + id );
        this.aon_customers_entries[ id ][ 'body' ] = body;
        this.aon_customers_entries[ id ][ 'eyes' ] = eyes;
        this.aon_customers_entries[ id ][ 'noses' ] = noses;
        this.aon_customers_entries[ id ][ 'mouths' ] = mouths;
        this.aon_customers_entries[ id ][ 'hair' ] = hair;
        this.aon_customers_entries[ id ][ 'fringes' ] = fringes;
        this.aon_customers_entries[ id ][ 'accessories' ] = accessories;
        this.aon_customers_entries[ id ][ 'hats' ] = hats;
        console.log( 'SAVE CUSTOMER IMAGE' ); 
        console.table( this.aon_customers_entries );
    },
    
    saveCustomerDetails( id, customer_details_age, customer_details_live, customer_details_interests, customer_details_habits, customer_details_activities, customer_details_feel_strongly ) {
        this.aon_customers_entries[ id ][ 'customer_details_age' ] = customer_details_age;
        this.aon_customers_entries[ id ][ 'customer_details_live' ] = customer_details_live;
        this.aon_customers_entries[ id ][ 'customer_details_interests' ] = customer_details_interests;
        this.aon_customers_entries[ id ][ 'customer_details_habits' ] = customer_details_habits;
        this.aon_customers_entries[ id ][ 'customer_details_activities' ] = customer_details_activities;
        this.aon_customers_entries[ id ][ 'customer_details_feel_strongly' ] = customer_details_feel_strongly;
        console.log( 'SAVE CUSTOMER DETAILS' );
        console.table( this.aon_customers_entries );
    },
    
    saveCustomerMemorableName( id, customer_memorable_name ) {
        this.aon_customers_entries[ id ][ 'customer_memorable_name' ] = customer_memorable_name;
        console.log( 'SAVE CUSTOMER MEMORABLE NAME' );
        console.table( this.aon_customers_entries );
    },
    
    saveCustomerBuyingHabits( id, buying_habits_product, buying_habits_buy_from_you, buying_habits_buy_for_them, buying_habits_buy_directly_from_you, buying_habits_how_will_you_reach ) {
        this.aon_customers_entries[ id ][ 'buying_habits_product' ] = buying_habits_product;
        this.aon_customers_entries[ id ][ 'buying_habits_buy_from_you' ] = buying_habits_buy_from_you;
        this.aon_customers_entries[ id ][ 'buying_habits_buy_for_them' ] = buying_habits_buy_for_them;
        this.aon_customers_entries[ id ][ 'buying_habits_buy_directly_from_you' ] = buying_habits_buy_directly_from_you;
        this.aon_customers_entries[ id ][ 'buying_habits_how_will_you_reach' ] = buying_habits_how_will_you_reach;
        console.log( 'SAVE CUSTOMER DETAILS' );
        console.table( this.aon_customers_entries );
    },
    
    saveCustomerIncome( id, yearly_income, customer_spend_with_you, how_many_customers ) {
        this.aon_customers_entries[ id ][ 'yearly_income' ] = yearly_income;
        this.aon_customers_entries[ id ][ 'customer_spend_with_you' ] = customer_spend_with_you;
        this.aon_customers_entries[ id ][ 'how_many_customers' ] = how_many_customers;
        console.log( 'SAVE CUSTOMER DETAILS' );
        console.table( this.aon_customers_entries );
        /*if ( this.checkCustomerCompleted(0) && this.checkCustomerCompleted(1) && this.checkCustomerCompleted(2) ) {
            $( '.customer_groups_next' ).removeClass( 'disabled' );
        } else {
            $( '.customer_groups_next' ).addClass( 'disabled' );
        }*/
        
        //
        // !! REVIEW THE WAY DATA IS LOADED AND RENDERED ETC !!
        // !! PROGRESS CHECKING ETC !!!
        //
        
    },
    
    checkCustomerCompleted( id ) {
            // Check all fields have been completed...
            console.log( 'checkCustomerCompleted -- ' + this.aon_customers_entries[ id ][ 'body' ] )
            var a = this.aon_customers_entries[ id ][ 'body' ];
            var b = this.aon_customers_entries[ id ][ 'eyes' ];
            var c = this.aon_customers_entries[ id ][ 'noses' ];
            var d = this.aon_customers_entries[ id ][ 'mouths' ];
            var e = this.aon_customers_entries[ id ][ 'hair' ];

            var f = this.aon_customers_entries[ id ][ 'customer_details_age' ];
            var g = this.aon_customers_entries[ id ][ 'customer_details_live' ];
            var h = this.aon_customers_entries[ id ][ 'customer_details_interests' ];
            var i = this.aon_customers_entries[ id ][ 'customer_details_habits' ];
            var j = this.aon_customers_entries[ id ][ 'customer_details_activities' ];
            var k = this.aon_customers_entries[ id ][ 'customer_details_feel_strongly' ];

            var l = this.aon_customers_entries[ id ][ 'buying_habits_product' ];
            var m = this.aon_customers_entries[ id ][ 'buying_habits_buy_from_you' ];
            var n = this.aon_customers_entries[ id ][ 'buying_habits_buy_for_them' ];
            var o = this.aon_customers_entries[ id ][ 'buying_habits_buy_directly_from_you' ];
            var p = this.aon_customers_entries[ id ][ 'buying_habits_how_will_you_reach' ];
            var q = this.aon_customers_entries[ id ][ 'yearly_income' ];
            var r = this.aon_customers_entries[ id ][ 'customer_spend_with_you' ];
            var s = this.aon_customers_entries[ id ][ 'how_many_customers' ];            
            var t = this.aon_customers_entries[ id ][ 'customer_memorable_name' ];            
            console.log( 'checkCustomerCompleted - all vars: ' );
            console.log( ' - a ' + a );
            console.log( ' - b ' + b );
            console.log( ' - c ' + c );
            console.log( ' - d ' + d );
            console.log( ' - e ' + e );
            console.log( ' - f ' + f );
            console.log( ' - g ' + g );
            console.log( ' - h ' + h );
            console.log( ' - i ' + i );
            console.log( ' - j ' + j );
            console.log( ' - k ' + k );
            console.log( ' - l ' + l );
            console.log( ' - m ' + m );
            console.log( ' - n ' + n );
            console.log( ' - o ' + o );
            console.log( ' - p ' + p );
            console.log( ' - q ' + q );
            console.log( ' - r ' + r );
            console.log( ' - s ' + s );
            console.log( ' - t ' + t );
            if ( a != '' && b != '' && c != '' && d != '' && e != '' && f != '' && g != '' && h != '' && i != '' && j != '' && k != '' && l != '' && m != '' && n != '' && o != '' && p != '' && q != '' && r != '' && s != '' && t != '' ) {
                return true;
            } else {
                return false;
            }
    },
    
    // Render existing customers, used also on the Business Plan page
    renderExistingCustomers() {
        
        console.log( 'Rendering Existing Customers...' );
        if ( $( '#section_3a_data_json' ).val() != '' ) { // If JSON data field is not empty then we presume this is saved data and try to load it...
            var section_3a_data_one_json = $( '#section_3a_data_json' ).val();
            this.aon_customers_entries = JSON.parse( section_3a_data_one_json );
            
            // Loop over entries array...
            var entry_count = 1;
            $.each( this.aon_customers_entries, function( index ) {
                // Show / Hide add / redo links and clone SVG...
                $( '#customer_' + entry_count + ' .main svg').remove();
                $( '#customer_dynamic .main svg' ).clone().appendTo( '#customer_' + entry_count + ' .main .svg_wrapper' );
                // Display SVG elements for the final Thumbnails...
                if ( this.body != '' ) {
                    $( '#customer_' + entry_count + ' .main .body .' + this.body ).show();
                }
                if ( this.eyes != '' ) {
                    $( '#customer_' + entry_count + ' .main .eyes .' + this.eyes ).show();
                }
                if ( this.noses != '' ) {
                    $( '#customer_' + entry_count + ' .main .noses .' + this.noses ).show();
                }
                if ( this.mouths != '' ) {
                    $( '#customer_' + entry_count + ' .main .mouths .' + this.mouths ).show();
                }
                if ( this.hair != '' ) {
                    $( '#customer_' + entry_count + ' .main .hair .' + this.hair ).show();
                }
                if ( this.fringes != '' ) {
                    $( '#customer_' + entry_count + ' .main .fringes .' + this.fringes ).show();
                }
                if ( this.accessories != '' ) {
                    $( '#customer_' + entry_count + ' .main .accessories .' + this.accessories ).show();
                }
                if ( this.hats != '' ) {
                    $( '#customer_' + entry_count + ' .main .hats .' + this.hats ).show();
                }

				if ( this.body != '' || this.eyes != '' || this.nose != '' || this.mouths != '' || this.hair != '' || this.fringes != '' || this.accessories != '' || this.hats != '' ) {
                //if ( this.body != '' && this.eyes != '' && this.noses != '' && this.mouths != '' && this.hair != '' ) {
                    $( '.customer_' + entry_count + ' .add_customer' ).hide();
                    $( '.customer_' + entry_count + ' .thumbnail, .customer_' + entry_count + ' .total' ).show();
                } else {
                    $( '.customer_' + entry_count + ' .redo_customer' ).show();
                    $( '.customer_' + entry_count + ' .thumbnail, .customer_' + entry_count + ' .total' ).hide();
                }

                // Set Income text on final step...
                $( '.customer_' + entry_count + ' .total_text' ).text( this.yearly_income );

                // Set Customer Name final step...
                $( '.customer_' + entry_count + ' .memorable_name' ).text( this.customer_memorable_name );

                entry_count++;

            });
        
            if ( $( '#customer_1 svg').length > 0 && $( '#customer_2 svg').length > 0 && $( '#customer_3 svg').length > 0 ) {
                $( '.customer_groups_next' ).removeClass( 'disabled' );
            } else {
                $( '.customer_groups_next' ).addClass( 'disabled' );
            }
			
			
			console.log('entry_count',entry_count);
			console.log('Current Step',aon_craft_step_navigation.current_step);
            
			//console.log('Customer 1',this.aon_customers_entries[0]['customer_memorable_name']);
			//console.log('Customer 2',this.aon_customers_entries[1]['customer_memorable_name']);
			//console.log('Customer 3',this.aon_customers_entries[2]['customer_memorable_name']);
			
			if ( entry_count > 1 ) {
				console.log('Entry count > 1, disable back button');
				//aon_craft_step_navigation.current_step = 1;
				$( '.section_3a .step_8 .back' ).addClass('disabled');
			}
			
			console.log('Current Step',aon_craft_step_navigation.current_step);
			
            // Remove source SVG and surrounding markup...
            /*if ( $( '#customer_1 .main .svg_wrapper svg' ).length > 0 && $( '#customer_2 .main .svg_wrapper svg' ).length > 0 && $( '#customer_3 .main .svg_wrapper svg' ).length > 0 ) {
                $( '#customer_dynamic' ).remove();
            }*/
        
            // This is just a precaution for the Business Plan page so that we don't end up with the default character shown if there's less than 3 characters in the data. Note that there shouldn't ever be less than 3 as we don't let the user complete section 3A unless they've completed all 3.
            if ( $( '#business_plan' ).length > 0 ) { 
                $( '#customer_dynamic' ).remove();
            }
            
        }
    },
    
    addCustomerDataEntry() {
        // Default variables for data structure...
        var body = '';
        var eyes = '';
        var noses = '';
        var mouths = '';
        var hair = '';
        var fringes = '';
        var accessories = '';
        var hats = '';
        var customer_details_age = '';
        var customer_details_live = '';
        var customer_details_interests = '';
        var customer_details_habits = '';
        var customer_details_activities = '';
        var customer_details_feel_strongly = '';
        var buying_habits_product = '';
        var buying_habits_buy_from_you = '';
        var buying_habits_buy_for_them = '';
        var buying_habits_buy_directly_from_you = '';
        var buying_habits_how_will_you_reach = '';
        var customer_spend_with_you = '';
        var how_many_customers = '';
        var yearly_income = '';
        var customer_memorable_name = '';
        // Push default data to data structure array...
        this.aon_customers_entries.push( { body, eyes, noses, mouths, hair, fringes, accessories, hats, customer_details_age, customer_details_live, customer_details_interests, customer_details_habits, customer_details_activities, customer_details_feel_strongly, buying_habits_product, buying_habits_buy_from_you, buying_habits_buy_for_them, buying_habits_buy_directly_from_you, buying_habits_how_will_you_reach, customer_spend_with_you, how_many_customers, yearly_income, customer_memorable_name } );
        console.table( 'addCustomerDataEntry: ' + this.aon_customers_entries );
    },
    
    loadData( mode ) {
        /*
         * Set Data.
         * Either load existing data from backend or set default blank data...
         */
        
        // Load data from backend...
        if ( mode == 'load_live' ) {
            // Load from json array in page
            var aon_section_3a_data_json = $( '#section_3a_data_json' ).val();
            this.aon_section_3a_data = JSON.parse( aon_section_3a_data_json );
            
        } else if ( mode == 'load_demo' ) {
            // Reset Customer Process
            this.resetCustomerCreatorProcess();
            
            // Set current customer to 1
            this.setCurrentCustomer( 1 );
            
            // Using temp JSON source for now, but this would load from the backend...
            var aon_customers_entries_json = '[';
            
                aon_customers_entries_json += '{"body":"red-body1", "eyes":"blue-eyes1", "noses":"purple-nose1", "mouths":"red-mouth1", "hair":"green-hair1", "fringes":"blue-fringe1", "accessories":"purple-accessory1", "hats":"green-hat1", "customer_details_age":"17-25", "customer_details_live":"Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum.", "customer_details_interests":"Cras justo odio, dapibus ac facilisis in, egestas eget quam.", "customer_details_habits":"Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.", "customer_details_activities":"Donec id elit non mi porta gravida at eget metus.", "customer_details_feel_strongly":"Cras justo odio, dapibus ac facilisis in, egestas eget quam.", "buying_habits_product":"Fishcakes", "buying_habits_buy_from_you":"Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.", "buying_habits_buy_for_them":"Donec ullamcorper nulla non metus auctor fringilla.", "buying_habits_buy_directly_from_you":"Curabitur blandit tempus porttitor.", "buying_habits_how_will_you_reach":"Phone marketing", "customer_spend_with_you":"300", "how_many_customers":"20", "yearly_income":"6000", "customer_memorable_name":"Joe"},';
                
                aon_customers_entries_json += '{"body":"blue-body1", "eyes":"green-eyes2", "noses":"red-nose1", "mouths":"blue-mouth1", "hair":"red-hair1", "fringes":"green-fringe1", "accessories":"red-accessory1", "hats":"blue-hat1", "customer_details_age":"6-10", "customer_details_live":"Morbi leo risus, porta ac consectetur ac, vestibulum at eros.", "customer_details_interests":"Nullam id dolor id nibh ultricies vehicula ut id elit.", "customer_details_habits":"Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.", "customer_details_activities":"Cras justo odio, dapibus ac facilisis in, egestas eget quam.", "customer_details_feel_strongly":"Aenean lacinia bibendum nulla sed consectetur.", "buying_habits_product":"Marshmallows", "buying_habits_buy_from_you":"Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.", "buying_habits_buy_for_them":"Etiam porta sem malesuada magna mollis euismod.", "buying_habits_buy_directly_from_you":"Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.", "buying_habits_how_will_you_reach":"Carrier pigeon", "customer_spend_with_you":"500", "how_many_customers":"10", "yearly_income":"5000", "customer_memorable_name":"Jane"},';
                
                aon_customers_entries_json += '{"body":"purple-body1", "eyes":"red-eyes1", "noses":"green-nose1", "mouths":"purple-mouth1", "hair":"blue-hair1", "fringes":"purple-fringe1", "accessories":"blue-accessory1", "hats":"green-hat1", "customer_details_age":"36-45", "customer_details_live":"Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.", "customer_details_interests":"Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.", "customer_details_habits":"Integer posuere erat a ante venenatis dapibus posuere velit aliquet.", "customer_details_activities":"Cras justo odio, dapibus ac facilisis in, egestas eget quam.", "customer_details_feel_strongly":"Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.", "buying_habits_product":"Cheese", "buying_habits_buy_from_you":"Cras justo odio, dapibus ac facilisis in, egestas eget quam.", "buying_habits_buy_for_them":"Maecenas faucibus mollis interdum.", "buying_habits_buy_directly_from_you":"Maecenas sed diam eget risus varius blandit sit amet non magna.", "buying_habits_how_will_you_reach":"Spam email", "customer_spend_with_you":"1000", "how_many_customers":"25", "yearly_income":"25000", "customer_memorable_name":"Brian"}';
                
                aon_customers_entries_json += ']';

            this.aon_customers_entries = JSON.parse( aon_customers_entries_json );
            
        } else if ( mode == 'start' ) {
            // Reset Customer Process
            this.resetCustomerCreatorProcess();
            
            // Set current customer to 1
            this.setCurrentCustomer( 1 );
            
            /*var aon_customers_entries_json = '[{"body":"", "eyes":"", "noses":"", "mouths":"", "hair":"", "fringes":"", "accessories":"", "hats":"", "customer_details_age":"", "customer_details_live":"", "customer_details_interests":"", "customer_details_habits":"", "customer_details_activities":"", "customer_details_feel_strongly":"", "buying_habits_product":"", "buying_habits_buy_from_you":"", "buying_habits_buy_for_them":"", "buying_habits_buy_directly_from_you":"", "buying_habits_how_will_you_reach":"", "customer_spend_with_you":"", "how_many_customers":"", "yearly_income":""},{"body":"", "eyes":"", "noses":"", "mouths":"", "hair":"", "fringes":"", "accessories":"", "hats":"", "customer_details_age":"", "customer_details_live":"", "customer_details_interests":"", "customer_details_habits":"", "customer_details_activities":"", "customer_details_feel_strongly":"", "buying_habits_product":"", "buying_habits_buy_from_you":"", "buying_habits_buy_for_them":"", "buying_habits_buy_directly_from_you":"", "buying_habits_how_will_you_reach":"", "customer_spend_with_you":"", "how_many_customers":"", "yearly_income":""},{"body":"", "eyes":"", "noses":"", "mouths":"", "hair":"", "fringes":"", "accessories":"", "hats":"", "customer_details_age":"", "customer_details_live":"", "customer_details_interests":"", "customer_details_habits":"", "customer_details_activities":"", "customer_details_feel_strongly":"", "buying_habits_product":"", "buying_habits_buy_from_you":"", "buying_habits_buy_for_them":"", "buying_habits_buy_directly_from_you":"", "buying_habits_how_will_you_reach":"", "customer_spend_with_you":"", "how_many_customers":"", "yearly_income":""}]';
            this.aon_customers_entries = JSON.parse( aon_customers_entries_json );*/
            
            /*var addCustomerDataEntry = ( ) => {
                
            }*/
            this.addCustomerDataEntry();
            //addCustomerDataEntry();
            //addCustomerDataEntry();
            
        }
        console.table( this.aon_customers_entries );
        console.log( 'this.aon_customers_entries[0][\'body\']: ' + this.aon_customers_entries[0]['body'] );
  
    },
        
    saveData() {
        // Call AJAX request to WP / Rest API
        // Save completed data to backend...
        var jsonDataString = JSON.stringify( this.aon_customers_entries );
        console.log( 'jsonDataString: ' + jsonDataString );
        
        console.log( '3A - CUSTOMER CREATOR - AJAX - START' );
        var meta = { 'section_3a_data_one' : jsonDataString };
        $.ajax({
            url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
            method: 'POST',
            beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
            },
            data: {
                'meta' : meta
            }
        }).done( function ( response ) {
            console.log( 'Response: ' );
            console.log( response );
        });
        console.log( '3A - CUSTOMER CREATOR - AJAX - END' );
        
        console.log( 'Saving data via AJAX, saving the following:' );
        console.table( this.aon_customers_entries );
    }

}